/**
 * The MJ shell detaches a surface without destroying it on tab switches and can
 * host duplicate/orphaned instances of the same dashboard (see the comments in
 * base-app-surface.component.ts). A stale detached instance still receives
 * Location$ emissions and would double-log every page view; only a host that
 * is actually in the document records.
 */
export function ShouldRecordPageView(host: HTMLElement): boolean {
    return host.isConnected;
}
